var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"y-video-modal",on:{"click":_vm.close}},[_c('div',{staticClass:"close"},[_c('CloseIcon')],1),_c('iframe',{attrs:{"src":this.srcAttribute}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }